<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :selectShow="false"
      :show="false"
      :submitData="submitData"
      @success="onSuccess"
      :goback="true"
    >
    </common-top-form>
    <div style="font-size: 14px; font-weight: bold; margin-bottom: 15px">
      <span>活动名称：{{ this.impiementall.activityName }} </span
      ><span style="margin-right: 15px; margin-left: 15px"
        >SN：{{ this.impiementall.sn }}</span
      >
    </div>
    <common-table
      :data="tableData"
      ref="commonTable"
      :isShow="false"
      @handleChange="getPage"
    >
      <el-table-column
        prop="batchId"
        min-width="100"
        label="期数"
      ></el-table-column>
      <el-table-column
        prop="dateStart"
        min-width="100"
        label="开始时间"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="dateEnd"
        min-width="100"
        label="结束时间"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="realityTransactions"
        label="达标交易量(元)"
        min-width="180"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="qualifiedTransactions"
        label="实际交易量(元)"
        min-width="180"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        :formatter="formatterTablestatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="update(scope.row)">更新 </el-button>
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import TransactionService from "service/TransactionService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "twoapppointsnewodetoJoyinfolook",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      isPage: false,
      page: {},
      formModel: {},
      impiementall: {},
      submitService: TransactionService.ThreeapppointsnewodetoJoyinfolookList,
      tableData: [],
      status: [
        {
          dictKey: "0",
          dictValue: "未启动",
        },
        {
          dictKey: "1",
          dictValue: "进行中",
        },
        {
          dictKey: "2",
          dictValue: "已结束",
        },
        {
          dictKey: "3",
          dictValue: "已完成",
        },
      ],
    };
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        pId: this.impiementall.id,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  created() {
    this.impiementall = JSON.parse(this.$route.params.item);
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  watch: {},
  methods: {
    handleFront() {
      this.$router.push({
        name: "organuser",
      });
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.onSuccess(res);
          this.isPage = false;
        },
        "信息获取失败"
      );
    },
    update(item) {
      this.showConfirm("是否执行？")
        .then(() => {
          this.doupdate(item.id);
        })
        .catch(() => {});
    },
    doupdate(id) {
      this.doLoad(
        TransactionService.ThreeapppointsnewodetoJoyinfolookupdate,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    formatterTablestatus(row, column, cellValue, index) {
      let value = "";
      this.status.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
.button-size-back {
  width: 120px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/ThreeAppPointsNewOdeToJoyInfoLook.vue